var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { PartialRoute } from "@irati/utils/history/routing";
import { injectIntl } from "@irati/utils/lang";
import { AccountWrapper } from "@irati/ui/src/Account";
import authentication from "@irati/auth";
import SideNavigation from "@irati/ui/src/Navigation/SideNavigation";
import accountMenuLinks from "../constants/accountMenuLinks";
import { AccountTrophies, AccountRecognition, AccountRewards } from "../containers/Account";
var AccountRoute = /** @class */ (function (_super) {
    __extends(AccountRoute, _super);
    function AccountRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountRoute.prototype.render = function () {
        var _a = this.props, match = _a.match, formatMessage = _a.formatMessage;
        var isRewardDisabled = authentication.apps("recognition.recognition.rewardDisabled");
        var menuLinks = accountMenuLinks(isRewardDisabled, this.props);
        var accountProps = {
            indexRedirect: "/my-recognition",
            MobileMenu: function () { return React.createElement(SideNavigation, { links: menuLinks }); },
            mobileBack: formatMessage({ id: "recognition.account.routes.recognition" }),
            Menu: function () { return React.createElement(SideNavigation, { links: menuLinks }); }
        };
        return (React.createElement(AccountWrapper, __assign({}, accountProps, { usesNewSideNav: true }),
            React.createElement(PartialRoute, { match: match.url, path: "/my-recognition", title: formatMessage({ id: "recognition.account.routes.recognition" }), component: AccountRecognition }),
            React.createElement(PartialRoute, { match: match.url, path: "/my-trophies", title: formatMessage({ id: "recognition.account.routes.trophies" }), component: AccountTrophies }),
            isRewardDisabled || React.createElement(PartialRoute, { match: match.url, path: "/my-rewards", title: formatMessage({ id: "recognition.account.routes.rewards" }), component: AccountRewards })));
    };
    return AccountRoute;
}(PureComponent));
export default injectIntl(AccountRoute);
